module.exports = __webpack_public_path__ + "img/tag_green_oval.42db6aef.svg";